import * as React from 'react';
import { makeStyles, createStyles, ButtonBase } from '@material-ui/core';
import cn from 'classnames';
import { BankType, useNewWaChatEventMutation } from '../../generated/graphql';
import { TranquiTheme } from '../../containers/App/theme';
import RenderText from '../../dictionaries/RenderText';
import { useGetGlobalSettingDomainByEntity } from '../../utils/useGetGlobalSettingDomainByEntity';

interface WaBtnProps {
  title?: string;
  msg?: string;
  className?: string;
  bank?: BankType;
}

const WaBtn: React.FC<WaBtnProps> = ({ msg, title, className, bank: _bank }) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const routeWa = encodeURIComponent(msg || 'Hola, tengo una consulta');

  const [ newWaChatEvent ] = useNewWaChatEventMutation({ onError: () => null });
  const handleClick = () => {
    newWaChatEvent();
  };

  const domainWhatsapp = useGetGlobalSettingDomainByEntity('domainWhatsapp');
  if (!domainWhatsapp) return null;
  const phoneNumber = domainWhatsapp.number;
  const cleanPhoneNumber = phoneNumber.replace(/[()\s]/g, '');

  return (
    <ButtonBase
      data-testid="wa-btn__wa-button"
      className={cn(className, classes.btn)}
      onClick={handleClick}
      component="a"
      target="_blank"
      rel="noopener noreferrer"
      href={`https://api.whatsapp.com/send?phone=${cleanPhoneNumber}&text=${routeWa}`}
      // href={`tel:${cleanPhoneNumber}`}
    >
      {title || <RenderText textKey="action_wa_button_text" context={{ phoneNumber }} />}
      {/* <RenderText textKey="action_call_button_text" context={{ phoneNumber }} /> */}
    </ButtonBase>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  btn: {
    ...theme.typography.capitalize as any,
    color: theme.palette.pearl.main,
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(1.2, 2),
    borderRadius: theme.spacing(0.5),
    textTransform: 'uppercase',
  },
}));

export default WaBtn;
